<script setup lang="ts">
import { useRouter } from "vue-router";
import { ROUTE_BLOG_SEARCH } from "~/constants/routes";

const router = useRouter();
const searchText = ref("");
const isShowSearch = ref(false);
const searchInputWrapper = ref(null);
const searchInput = ref();

const openSearch = () => {
  isShowSearch.value = true;
  searchInput.value.focus();
  onClickOutside(searchInputWrapper, () => {
    isShowSearch.value = false;
    searchText.value = "";
  });
};

const clearSearchText = () => {
  searchText.value = "";
};

const submitSearch = async () => {
  if (searchText.value) {
    router.push({ path: ROUTE_BLOG_SEARCH, query: { q: searchText.value } });
  }
};
</script>
<template>
  <a
    href="#"
    class="icon-main-search tw-p-[14px] tw-text-[19px] tw-flex tw-items-center tw-justify-center"
    @click="openSearch"
  ></a>
  <form
    data-algolia-search-form
    role="search"
    method="get"
    :class="{ active: isShowSearch }"
    class="search-form tw-absolute tw-inset-0 tw-m-auto tw-overflow-hidden tw-w-0 tw-transition-all tw-duration-300 tw-ease-linear tw-z-[2] tw-bg-nl-yellow-100 tw-flex tw-items-center tw-justify-center [&.active]:tw-w-full [&.active]:tw-visible"
    @submit.prevent="submitSearch"
  >
    <div
      ref="searchInputWrapper"
      class="sm:tw-max-w-[372px] tw-w-full tw-flex tw-relative tw-mx-[13px] sm:tw-mx-0"
    >
      <i
        class="icon-main-times tw-z-1 tw-absolute tw-bottom-[13px] tw-left-2.5 tw-cursor-pointer tw-text-nl-green-100"
        @click="clearSearchText"
      ></i>
      <input
        ref="searchInput"
        v-model="searchText"
        type="text"
        aria-label="Search input"
        data-algolia-search-input
        class="tw-flex-1 tw-w-full tw-bg-transparent tw-border-0 tw-border-b-2 tw-border-nl-green-100 tw-text-nl-green-100 tw-font-bookmania tw-text-[16px] sm:tw-text-[18px] tw-font-medium tw-pt-[7px] tw-pl-[42px] tw-tracking-[0.08em] tw-min-w-0 tw-placeholder-nl-green-100"
        placeholder="Search Blog"
      />
      <input
        id="searchsubmit"
        data-algolia-submit-input
        type="submit"
        class="tw-bg-[#ffcb05] hover:tw-bg-[#e7b700] tw-font-bold tw-text-nl-green-100 tw-font-bookmania tw-text-[14px] tw-rounded-b-none tw-w-[106px]"
        value="Search"
      />
    </div>
  </form>
</template>
